export interface IRestOptions {
  idField?: string;
  pageQueryParam?: string;
  limitQueryParam?: string;
  searchTextQueryParam?: string;
}
